import {Injectable, ErrorHandler, Injector, NgZone, Output, EventEmitter} from '@angular/core';
import {HttpErrorResponse} from '@angular/common/http';
import {Router} from '@angular/router';
import {ErrorPageModel} from '../../models/ErrorPageModel';
import {ErrorPageService} from './error-page.service';

@Injectable
({
  providedIn: 'root'
})
export class GlobalErrorHandlerService implements ErrorHandler
{
  constructor(private injector: Injector, private ngZone: NgZone, private errorPageService: ErrorPageService)
  {

  }

  handleError(error: any)
  {
    if (error instanceof HttpErrorResponse)
    {
      // Backend returns unsuccessful response codes such as 404, 500 etc.
      const errorPageModel: ErrorPageModel = new ErrorPageModel(error.status, error.message);
      this.errorPageService.errorPageModel = errorPageModel;

      const router = this.injector.get(Router);
      this.ngZone.run(() => router.navigate(['error'])).then();
    }
    else
    {
      // A client-side or network error occurred.
    }
  }
}
